<template>
  <div class="container">
    <br>
    <br>
    <footer class="pt-4 my-md-5 pt-md-5 border-top bap-title">
      <div class="row">
        <div class="col-12 col-md">
          <img alt="binliang-alexander-peng-logo" :src="cdnBaseUrl+'logo.png'" style="height: 50px;">
          <small ><LanguageSwitch></LanguageSwitch></small>
          <small ><span class="d-block text-muted bap-title bap-title">Binliang Alexander Peng</span></small>
          <small ><span class="d-block text-muted bap-title bap-title">10 Place Vendôme</span></small>
          <small ><span class="d-block text-muted bap-title bap-title">75001 Paris</span></small>
          <small ><span class="d-block text-muted bap-title bap-title">Copyright (c) {{ currentYear }}</span></small>
          <small class="d-block mb-3 text-muted "><span class="bap-title">{{
              $t('footer.copyright.line2')
            }}</span></small>
        </div>
        <div class="col-6 col-md">
          <h6>Suivez-nous</h6>
          <ul class="list-unstyled text-small">
            <li>
              <div class="row">
                <div class="col-2" style="margin-top: 5px;">
                  <a  @click="clickFooter('INSTA')"  href="https://www.instagram.com/binliang.alexander.peng/" target="_blank">
                    <InstagramIcon width="30px"></InstagramIcon>
                  </a>
                </div>

                <div class="col-2">
                  <a @click="clickFooter('TIKTOK')" href="https://www.tiktok.com/@binliang.alexander.peng" target="_blank" >
                    <TikTokIcon width="30px" ></TikTokIcon>
                  </a>
                </div>
                <div class="col-2">
                  <a @click="clickFooter('PINTEREST')" href="https://www.pinterest.fr/binliangalexanderpeng/" target="_blank" >
                    <PinterestIcon  width="30px" ></PinterestIcon>
                  </a>
                </div>
                <div class="col-2" style="margin-top: 5px;">
                  <a @click="clickFooter('FB')" href="https://www.facebook.com/BinliangAlexanderPeng/" target="_blank" >
                    <FacebookIcon width="30px" ></FacebookIcon>
                  </a>
                </div>
              </div>


            </li>
          </ul>
        </div>
        <div class="col-6 col-md">
          <h6>{{ $t('footer.aboutus.title') }}</h6>
          <ul class="list-unstyled text-small">
            <li>
              <router-link @click="clickFooter('JEWELLER')"  class=" text-muted footer-links" :to="{ name: routeNames.THE_JEWELLER }">
                {{ $t('footer.aboutus.companyHistory') }}
              </router-link>
            </li>
            <li>
              <router-link  @click="clickFooter('ARTISANAL')"  class=" text-muted footer-links" :to="{ name: routeNames.ARTISANAL }">
                {{ $t('footer.aboutus.productionProcess') }}
              </router-link>
            </li>
            <li>
              <router-link  @click="clickFooter('BESPOKE')" class=" text-muted footer-links" :to="{ name: routeNames.SUR_MESURE }">
                {{ $t('footer.aboutus.bespoke') }}
              </router-link>
            </li>
            <li>
              <router-link @click="clickFooter('PRESS')"  class=" text-muted footer-links" :to="{ name: routeNames.PRESSE }">{{
                  $t('footer.aboutus.press')
                }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-6 col-md">
          <h6>{{ $t('footer.apropos.title') }}</h6>
          <ul class="list-unstyled">
            <li>
              <router-link  @click="clickFooter('LEGAL')"   class=" text-muted footer-links" :to="{ name: routeNames.LEGAL_MENTIONS }">
                {{ $t('footer.apropos.legalMentions') }}
              </router-link>
            </li>
            <li>
              <router-link @click="clickFooter('CGV')" class="text-muted footer-links" :to="{ name: routeNames.CGV }">{{
                  $t('footer.apropos.cgv')
                }}
              </router-link>
            </li>
          </ul>
        </div>

      </div>
    </footer>
  </div>
</template>

<script>
import RouteNames from "@/routeNames";
import InstagramIcon from "@/components/InstagramIcon";
import FacebookIcon from "@/components/FacebookIcon";
import LanguageSwitch from "@/components/LanguageSwitch";
import TikTokIcon from "@/components/TikTokIcon.vue";
import PinterestIcon from "@/components/PinterestIcon.vue";
import Webservice from "@/webservice";

export default {
  name: "FooterElement",
  components: {PinterestIcon, TikTokIcon, LanguageSwitch, FacebookIcon, InstagramIcon},
  data() {
    let currentYear = new Date().getFullYear()  // returns the current year
    return {
      currentYear: currentYear,
      cdnBaseUrl: process.env.VUE_APP_CDN_BASE_URL,
      routeNames: RouteNames,
    }
  },
  methods: {

    clickFooter(item){
      Webservice.trackAction("CLICK_FOOTER_"+item, this.$route)
    }

  }
}
</script>

<style scoped>
.footer-links {
  font-size: 0.9rem;
}

</style>
